import { Box, VStack, HStack } from '@terra/ui-styled-system';
import { BodyStrong, MetaDefault } from '../../components/typography';
import type { ReactNode } from 'react';

export type ContentCardProps = {
  title?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  rightSlot?: ReactNode;
  hasBackground?: boolean;
  hasPadding?: boolean;
  textAlign?: 'left' | 'center' | 'right';
  minHeight?: string;
};

export const ContentCard = ({
  title,
  description,
  children,
  rightSlot,
  hasBackground = true,
  hasPadding = true,
  textAlign = 'left',
  minHeight,
}: ContentCardProps) => {
  const hasTitleOrDescription = !!title || !!description;

  return (
    <Box
      p={hasPadding ? 4 : 0}
      minHeight={minHeight}
      {...(hasBackground && {
        borderWidth: '1px',
        borderRadius: 'lg',
        borderColor: 'border.neutral.subtle',
        bg: 'bg.neutral.default',
      })}
    >
      <VStack alignItems="stretch" gap={4}>
        {(hasTitleOrDescription || rightSlot) && (
          <HStack justifyContent="space-between" alignItems="center" gap={4}>
            {hasTitleOrDescription ? (
              <VStack
                gap={1}
                alignItems="stretch"
                flex={1}
                minW={0}
                textAlign={textAlign}
              >
                {typeof title === 'string' ? (
                  <BodyStrong color="fg.neutral.default">{title}</BodyStrong>
                ) : (
                  title
                )}
                {typeof description === 'string' ? (
                  <MetaDefault color="fg.muted">{description}</MetaDefault>
                ) : (
                  description
                )}
              </VStack>
            ) : null}
            {rightSlot && <Box flexShrink={0}>{rightSlot}</Box>}
          </HStack>
        )}
        {children}
      </VStack>
    </Box>
  );
};
